import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';

const GetStarted = () => {
    useEffect(() => {
        AOS.init({ duration: 800, once: false });
    }, []);

    const navigate = useNavigate();
    const goToIDO = () => {
        navigate('/launchpads');
    }

    return (
        <div className="main-get-started">
            <div className="video-bot">
                <video
                    playsInline
                    webkit-playsinline
                    autoPlay
                    muted
                    loop
                    style={{ width: "100%", height: "auto" }}
                >
                    <source src="https://tinyblock.s3.ap-southeast-1.amazonaws.com/CTA.mp4" type="video/mp4" />
                </video>
            </div>

            <div className="video-bot-mo">
                <video
                    playsInline
                    webkit-playsinline
                    autoPlay
                    muted
                    loop
                    style={{ width: "100%", height: "auto" }}
                >
                    <source src="https://tinyblock.s3.ap-southeast-1.amazonaws.com/CTA-mo.mp4" type="video/mp4" />
                </video>
            </div>


            <div className="wrap-get-started" data-aos="fade-up">
                <div className="content-started">
                    <div className="title">
                        <span>Get started</span> today <br /> with TinyBlock
                    </div>
                    <div className="desc" data-aos="fade-up" data-aos-delay="200">
                        Join early-stage Web3 token sales, earn rewards, and unlock exclusive opportunities.
                    </div>
                    <div className="group-button" data-aos="fade-up" data-aos-delay="400">
                        <div className="btn-item">
                            <button className="main-button res" onClick={goToIDO} >
                                View Detail
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GetStarted;